import { createTheme, Theme, ThemeOptions } from "@mui/material";

import { darkPalette } from "./palette/darkPalette";
import { typography } from "./typography";
import { RefinePalettes } from "./palette";

const commonThemeProperties: ThemeOptions = {
  shape: {
    borderRadius: 6,
  },
  typography: {
    ...typography,
  },
};

const DarkTheme = createTheme({
  ...commonThemeProperties,
  palette: darkPalette,
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage:
            "linear-gradient(rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0.025))",
        },
      },
    },
    MuiAppBar: {
      defaultProps: {
        color: "transparent",
      },
    },
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontWeight: 800,
          lineHeight: "2rem",
        },
      },
    },
  },
});

const RefineThemes = Object.keys(RefinePalettes).reduce((acc, key) => {
  const paletteName = key as keyof typeof RefinePalettes;

  return {
    ...acc,
    [key]: createTheme({
      palette: {
        ...RefinePalettes[paletteName],
      },
    }),
  };
}, {}) as Record<keyof typeof RefinePalettes, Theme>;

export { DarkTheme, RefineThemes };
